const enabled =
  String(import.meta.env.VITE_ENABLE_TEST_ATTRS ?? "").trim().toLowerCase() === "true" ||
  import.meta.env.MODE === "test";

type AttrValue = string | number | boolean | null | undefined;

/**
 * Returns the supplied data-* attributes only when VITE_ENABLE_TEST_ATTRS=true.
 * Spread onto JSX elements: <div {...testAttrs({ 'data-testid': 'foo' })} />
 * In production builds (or when the flag is absent) this returns {} so no
 * test attributes reach the rendered HTML.
 */
export function testAttrs(attrs: Record<string, AttrValue>): Record<string, AttrValue> {
  return enabled ? attrs : {};
}
